/**
 * Gate minimal pour l'admin du Test de qualification de La Régie — protégé
 * par WorkOS comme le reste du cockpit (mêmes composants `Authenticated`/
 * `Unauthenticated`/`AuthLoading` que `AuthGate` dans `App.tsx`), mais SANS
 * `OrgGate` ni `CockpitShell` : juste la page admin, cf. mission (pas de
 * chrome cockpit pour cette surface dédiée). Extrait dans son propre
 * fichier (plutôt qu'inline dans `App.tsx` comme `AuthGate`) pour ne pas
 * ajouter une 3e paire composant+non-composant à ce fichier déjà dense.
 *
 * Mode maquette (`?mock=1`, DEV uniquement) : contourne le gate WorkOS pour
 * pouvoir screenshoter les 3 onglets admin SANS session — sinon `?mock=1`
 * rendrait quand même l'écran de login (le mock ne couvre que la couche
 * API, pas l'auth). Toujours derrière `IS_MOCK_MODE` (donc jamais vrai en
 * prod, cf. `api.ts`) — en prod ce composant se comporte exactement comme
 * avant.
 */
import { Authenticated, AuthLoading, Unauthenticated } from "convex/react";

import { AuthLoadingScreen, LoginScreen } from "@/core/auth";

import { IS_MOCK_MODE } from "./api";
import { RegieTestAdminPage } from "./RegieTestAdminPage";

export function RegieTestAdminGate() {
  if (IS_MOCK_MODE) {
    return <RegieTestAdminPage />;
  }

  return (
    <>
      <AuthLoading>
        <AuthLoadingScreen />
      </AuthLoading>
      <Unauthenticated>
        <LoginScreen />
      </Unauthenticated>
      <Authenticated>
        <RegieTestAdminPage />
      </Authenticated>
    </>
  );
}
